import { Link } from "react-router-dom";

export default function SiteFooter() {
  return (
    <footer className="bg-primary-950 text-background-100 mt-20">
      <div className="w-full px-4 md:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 rounded-md bg-accent-500 text-primary-950 flex items-center justify-center text-lg">
                <i className="ri-play-fill" aria-hidden="true"></i>
              </span>
              <span className="font-heading font-bold text-xl text-background-50">69视频</span>
            </div>
            <p className="text-sm text-background-200/80 leading-relaxed">
              丰富的视频资源平台，涵盖电影、电视剧与短视频，帮助你快速发现想看的内容。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">内容分类</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/category/movie" className="text-background-200/80 hover:text-accent-400 transition-colors cursor-pointer">电影</Link></li>
              <li><Link to="/category/tv" className="text-background-200/80 hover:text-accent-400 transition-colors cursor-pointer">电视剧</Link></li>
              <li><Link to="/category/short" className="text-background-200/80 hover:text-accent-400 transition-colors cursor-pointer">短视频</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">关于平台</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/about" className="text-background-200/80 hover:text-accent-400 transition-colors cursor-pointer">关于我们</Link></li>
              <li><Link to="/about" className="text-background-200/80 hover:text-accent-400 transition-colors cursor-pointer">服务与版权声明</Link></li>
              <li><Link to="/" className="text-background-200/80 hover:text-accent-400 transition-colors cursor-pointer">返回首页</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">联系方式</h4>
            <ul className="space-y-2 text-sm text-background-200/80">
              <li className="flex items-center gap-2"><i className="ri-mail-line" aria-hidden="true"></i>contact@69video.com</li>
              <li className="flex items-center gap-2"><i className="ri-weibo-line" aria-hidden="true"></i>@69视频官方</li>
              <li className="flex items-center gap-2"><i className="ri-wechat-line" aria-hidden="true"></i>69video-official</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-100/15 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-200/60">
          <p>© 2026 69视频 版权所有 · 本站内容均为演示示例，不提供真实视频播放与下载</p>
          <p>仅供学习与演示用途</p>
        </div>
      </div>
    </footer>
  );
}